export default __webpack_public_path__ + "static/media/imgBg.798c3445.webp";